import LocomotiveScroll from "locomotive-scroll";
import { Global } from "./../global";
import { PromotionBnr } from "./../_click/promotionBanner";
import { LineModal } from "./../_click/lineModal";
import { HeadSnowAni } from "./../_animation/headSnowAnimation";
import { TopSnowAnimation } from "./../_animation/topSnowAnimation";

export const Locomo = {
  init: page => {
    Global.isHeadMotionArr=[];
    Global.loco = new LocomotiveScroll({
      el: document.querySelector("[data-scroll-container]"),
      // smooth: Global.isIE == true ? false : true, // true
      reloadOnContextChange: true,
      // smooth: Global.isIE == true ? false : page == "Contact" ? false : true,
      smooth: (Global.isIE) ? false : true,
      // reloadOnContextChange:true,
      // scrollbarContainer:false,
      // resetNativeScroll: true,
      // repeat: true,
      smartphone: {
        // smooth: true
        // smooth: page == "Contact" || page == "Company" ? false : true
        // smooth: page == "Contact" ? false : true,
        smooth: false
        // draggingClass: "has-scroll-dragging"
        // touchMultiplier: 1
      },
      tablet: {
        // smooth: Global.isIE == true ? false : true // true
        smooth: false
        // touchMultiplier: 1
      }
    });

    if(!Global.isIE){
      Global.loco.on('scroll', obj=>{
        if(page=="Product"){
          let featureItem=document.querySelectorAll('.feature-list .item');
          document.querySelectorAll('.guide-list .guide-pos').forEach(function(item,i){
            if(item.classList.contains("is-inview")){
              for (let j=0,li=featureItem.length;j<li;j++){
                featureItem[j].classList.remove('is-on');
              }
              featureItem[i].classList.add('is-on')
            }
          })
        
        }
  
        if(page=="Home"){
          if(Global.isBanner){
            Locomo.bannerHandle(obj)
          }
          // top mv
          Locomo.topMainVisualHandle(obj)
          if(Global.isTopMvTimerActive){ // mvエリアにいる
            if(Global.isTopMvTimerRestart){
              Global.isTopMvTimerRestart=false
              // タイマースタート
              TopSnowAnimation.ready();
              // console.log('タイマーゴー')
            }
          }
          else{ // mvエリアにいない
            if(!Global.isTopMvTimerRestart){
              Global.isTopMvTimerRestart=true;
              // タイマー止める 初期化
              TopSnowAnimation.initialize();

              if(Global.isLineModal){
                LineModal.fadeIn()
              }
              // console.log('タイマーストップ')
            }
          }
  
        }
  
        if(Global.isTrans){
          if(Global.isHeadAnimaEnd){
            Locomo.headMotion();
          }
        }
      });

    }
  },
  headMotion:()=>{
    document.querySelectorAll('.is-headContainer').forEach(function(item,i){
      if(item.classList.contains("is-inview")) {
        if(Global.isHeadMotionArr[i] == undefined){
          Global.isHeadMotionArr[i]=false;
          HeadSnowAni.ready(i)
          // console.log('yeeeeeeeeeeah!!')
        }
      }
    })
  },
  topMainVisualHandle:(obj)=>{
    if(obj.scroll.y>=650){
      Global.isTopMvTimerActive=false
    }
    else{
      Global.isTopMvTimerActive=true
    }
    // return (obj.scroll.y>=700) ? false : true;
  },
  bannerHandle:function(obj){
    let S=obj.scroll.y-(Global.body.clientHeight-2000);
    S>0 ? PromotionBnr.fadeOut() : PromotionBnr.fadeIn()
  },
  update:()=>{
    Global.loco.update();
  },
  scrollToTop:()=>[
    document.querySelector(".footer__toTop").addEventListener("click",function(){
      Global.loco.scrollTo('top', {
        'offset': 0,
        // 'callback': function() {},
        'duration': 1600,
        'easing': [0.77, 0, 0.175, 1],
        'disableLerp': true
      } );
    })
  ],
  destory: () => {
    Global.loco.destroy();
  }
};
